export default {"src":"/_next/static/media/right-bold.f5a4b4db.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};